import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
// The app's own fonts, bundled and served from our origin (the CSP allows no font hosts).
import '@fontsource-variable/figtree'
import { App } from './App'
import { watchPictures } from './lib/motion'
import { registerServiceWorker } from './lib/offline'
import { applyPlatform } from './lib/platform'
import { keepPinnedOnScreen } from './lib/viewport'
import './index.css'

applyPlatform()
watchPictures()

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30_000 } } })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)

registerServiceWorker()
keepPinnedOnScreen()
